module.exports = __webpack_public_path__ + "img/0Q3A2496_P_L_BlackMatted.a9c99190.jpg";